import AppConsts from "@lib/appconst"
import { CustomerPotentialModel } from "@models/customer/customerPotentialModel"
import { RowData } from "@models/DataTable"
import dayjs from "dayjs"
const { activityType } = AppConsts

export interface IRowInquiry {
  moveInDate?: any
}

export class RowInquiryModel extends RowData implements IRowInquiry {
  moveInDate: any
  constructor() {
    super()
  }

  public static assign(obj) {
    if (!obj) return undefined

    const newObj = Object.assign(new RowInquiryModel(), obj)
    newObj.moveInDate = obj.moveInDate ? dayjs(obj.moveInDate) : undefined

    return newObj
  }

  public static assigns<T>(objs) {
    const results: any[] = []
    objs?.forEach((item) => results.push(this.assign(item)))
    return results
  }
}

export class InquiryDetailModel extends RowData {
  constructor() {
    super()
  }

  public static assign(obj) {
    if (!obj) return undefined

    const newObj = Object.assign(new RowInquiryModel(), obj)
    newObj.facings = obj.facings?.map((val) => ({
      label: val,
      value: val,
    }))
    newObj.bedRooms = obj.bedRooms?.map((val) => ({
      label: val,
      value: val,
    }))
    newObj.bathRooms = obj.bathRooms?.map((val) => ({
      label: val,
      value: val,
    }))
    newObj.progresses = obj.progresses?.map((val) => ({
      label: val,
      value: val,
    }))
    newObj.legals = obj.legals?.map((val) => ({
      label: val,
      value: val,
    }))
    newObj.facilities = obj.inquiryFacilityMap?.map((val) => ({
      label: val.name,
      value: val.id,
    }))
    newObj.projectFacilities = obj.inquiryProjectFacilityMap?.map((val) => ({
      label: val.name,
      value: val.id,
    }))
    newObj.views = obj.inquiryViewMap?.map((val) => ({
      label: val.name,
      value: val.id,
    }))
    newObj.kitchenViews = obj.inquiryKitchenViewMap?.map((val) => ({
      label: val.name,
      value: val.id,
    }))
    newObj.balconyViews = obj.inquiryBalconyViewMap?.map((val) => ({
      label: val.name,
      value: val.id,
    }))
    newObj.areas = obj.inquiryAreaMap?.map((area) => ({
      label: area?.provinceName,
      value: area?.id,
    }))
    newObj.townshipAreaIds = obj.inquiryTownshipAreaMap?.map((item) => ({
      label: item?.name,
      value: item?.id,
    }))
    newObj.townships = obj.inquiryTownshipMap?.map((township) => ({
      label: township?.name,
      value: township?.id,
    }))
    newObj.projects = obj.inquiryProjectMap?.map((project) => ({
      label: project?.projectName,
      value: project?.id,
    }))
    newObj.propertyTypes = obj.inquiryPropertyTypeMap?.map((item) => ({
      label: item?.name,
      value: item?.id,
    }))
    newObj.customer = CustomerPotentialModel.assign(obj.customer)
    return newObj
  }

  public static assigns<T>(objs) {
    const results: any[] = []
    objs?.forEach((item) => results.push(this.assign(item)))
    return results
  }
}

export class InquiryUpdateModel {
  id: any
  constructor() {
    this.id = undefined
  }

  public static assign(obj) {
    if (!obj) return undefined

    const newObj = Object.assign(new RowInquiryModel(), obj)
    newObj.facings = obj.facings?.map((i) => i.value)

    newObj.bedRooms = obj.bedRooms?.map((i) => i.value)
    newObj.bathRooms = obj.bathRooms?.map((i) => i.value)
    newObj.progresses = obj.progresses?.map((i) => i.value)
    newObj.legals = obj.legals?.map((i) => i.value)
    newObj.facilityIds = obj.facilities?.map((i) => i.value)
    newObj.projectFacilityIds = obj.projectFacilities?.map((i) => i.value)
    newObj.townshipIds = obj.townships?.map((i) => i.value)
    newObj.viewIds = obj.views?.map((i) => i.value)
    newObj.kitchenViewIds = obj.kitchenViews?.map((i) => i.value)
    newObj.balconyViewIds = obj.balconyViews?.map((i) => i.value)
    newObj.areaIds = obj.areas?.map((area) => area?.value)
    newObj.townshipAreaIds = obj.townshipAreaIds?.map((item) => item?.value)
    newObj.propertyTypeIds = obj.propertyTypes?.map((item) => item?.value)
    newObj.projectIds = obj.projects?.map((project) => project?.value)
    return newObj
  }

  public static assigns<T>(objs) {
    const results: any[] = []
    objs?.forEach((item) => results.push(this.assign(item)))
    return results
  }
}
export interface IInquiryItemModel {
  id?: number
  contactId?: number
  companyId?: number
  title?: string
  contactName?: string
  isPrimary?: boolean
  isActive?: boolean
}

export class InquiryItemModel {
  id?: number
  contactId?: number
  companyId?: number
  title?: string
  contactName?: string
  isPrimary?: boolean
  isActive?: boolean

  constructor(isPrimary?) {
    this.isPrimary = isPrimary
  }
}
export class InquirySimpleModel {
  id?: any
  name?: any
  contactId?: any
  contactName?: any
  occupierName?: any
  leaseTerm?: any
  moveInDate?: any

  public static assign(obj) {
    if (!obj) return undefined

    const newObj = Object.assign(new InquirySimpleModel(), obj)
    ;(newObj.id = obj.id),
      (newObj.name = `${obj.inquiryName} - ${obj.contact?.contactName} - ${obj.creatorUser?.displayName}`),
      (newObj.contactId = obj.contactId),
      (newObj.contactName = obj.contact?.contactName),
      (newObj.occupierName = obj.occupierName),
      (newObj.leaseTerm = obj.leaseTerm !== 0 ? obj.leaseTerm : undefined),
      (newObj.moveInDate = obj.moveInDate ? dayjs(obj.moveInDate) : undefined)

    return newObj
  }

  public static assigns<T>(objs) {
    const results: any[] = []
    objs?.forEach((item) => results.push(this.assign(item)))
    return results
  }
}
export class ActivityModel {
  type?: any

  public static assign(obj) {
    if (!obj) return undefined

    const newObj = Object.assign(new ActivityModel(), obj)
    if (obj.inquiryCall) {
      newObj.type = activityType.call
    } else if (obj.inquiryMail) {
      newObj.type = activityType.mail
    } else if (obj.inquiryProposal) {
      newObj.type = activityType.proposal
    } else if (obj.inquirySiteVisit) {
      newObj.type = activityType.sitevisit
    } else if (obj.inquiryReservation) {
      newObj.type = activityType.reservation
    }

    return newObj
  }

  public static assigns<T>(objs) {
    const results: any[] = []
    objs?.forEach((item) => results.push(this.assign(item)))
    return results
  }
}
